/** The strings for this feature, in the active language — see src/lib/i18n.js. */
import { pickLocale } from '../../lib/i18n'
import * as ar from './strings.ar'
import * as en from './strings.en'

export const transactionsStrings = pickLocale(ar.transactionsStrings, en.transactionsStrings)
export const resetLogsStrings = pickLocale(ar.resetLogsStrings, en.resetLogsStrings)
export const analysisStrings = pickLocale(ar.analysisStrings, en.analysisStrings)
export const gamificationSettingsStrings = pickLocale(ar.gamificationSettingsStrings, en.gamificationSettingsStrings)
